import { adminRoutes } from '@/admin-user/constants/routes';
import {
  resetImpersonation,
  selectImpersonationActive,
  selectImpersonationAdminTokens,
  selectImpersonationReturnTo,
} from '@/admin-user/stores/impersonation-slice';
import { setUser } from '@/auth/stores/auth-slice';
import { getCurrentUser } from '@/auth/stores/usecases/get-current-user';
import { hydrateUser } from '@/auth/stores/usecases/hydrate-user';
import { resetFeatureStores } from '@/common/lib/reset-feature-stores';
import { tokenStorage } from '@/common/lib/token-storage';
import { store } from '@/common/redux/store';

export const stopImpersonation = async (): Promise<void> => {
  const state = store.getState();
  if (!selectImpersonationActive(state)) return;

  const { accessToken: adminAccessToken, refreshToken: adminRefreshToken } = selectImpersonationAdminTokens(state);
  const returnTo = selectImpersonationReturnTo(state);

  // Clear the admin token snapshot immediately (rather than after the async work below) so it
  // never lingers longer than necessary, whether this succeeds or throws.
  store.dispatch(resetImpersonation());

  try {
    await resetFeatureStores();

    if (adminAccessToken) {
      await tokenStorage.setAccessToken(adminAccessToken);
      if (adminRefreshToken) {
        await tokenStorage.setRefreshToken(adminRefreshToken);
      } else {
        await tokenStorage.clearRefreshToken();
      }
      // We don't persist the admin's original expiry (see the impersonation slice's storage
      // comment in store.ts), so force the next request to refresh immediately using the
      // restored refresh token.
      await tokenStorage.setExpiresAt(1);
    }

    const adminUser = await getCurrentUser();
    if (adminUser) {
      store.dispatch(setUser(adminUser));
      // Feature stores (preferences, institution…) were reset above and are persisted, so the
      // admin's profile must be re-fetched here or the auth guard sends them to onboarding.
      await hydrateUser(adminUser);
    }
  } finally {
    window.location.href = returnTo ?? adminRoutes.users;
  }
};
